import * as baseUtils from './baseUtils';

// className 합치기
export const classNameBind = (arr: string[]) =>
  arr.filter(el => el !== '').join(' ');

// string 문자열 찾기
export const setSearchStr = (str: string, val: string) => str.includes(val);

// string 문자열에 콤마(',')를 찍고, 구분자를 뒤에 붙여준다
export const setComma = (str: string, separator?: string) => {
  let result = '';

  if (!baseUtils.isEmpty(str) || str === '0') {
    const temp = String(str);
    result = temp.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');

    if (!baseUtils.isEmpty(separator)) {
      result += separator;
    }
  }

  return result;
};

// 이름 마스킹 처리
export const setNameMasking = (name: string) => {
  let result = '';

  if (!baseUtils.isEmpty(name)) {
    const nameLength = name.length;

    if (nameLength === 1) {
      // 1자리: 마스킹 없이 그대로 반환
      result = name;
    } else if (nameLength === 2) {
      // 2자리: 마지막 자리 마스킹 (공명 → 공*)
      result = `${name.charAt(0)}*`;
    } else if (nameLength === 3) {
      // 3자리: 가운데 한자리 마스킹 (김남준 → 김*준)
      result = `${name.charAt(0)}*${name.charAt(2)}`;
    } else {
      // 4자리 이상: 맨앞, 맨 마지막 자리 제외 후 마스킹 (제갈공명 → 제**명)
      const firstChar = name.charAt(0);
      const lastChar = name.charAt(nameLength - 1);
      const maskingLength = nameLength - 2;
      const masking = '*'.repeat(maskingLength);

      result = `${firstChar}${masking}${lastChar}`;
    }
  }

  return result;
};

// Array Size만큼 분리.
export const arrayDivision = (data: unknown[], size = 1) => {
  const items = [...data];
  const arr = [];

  while (items.length) {
    arr.push(items.splice(0, size));
  }

  return arr;
};

export const getAge = (dateString: string, useKoranAge = true) => {
  if (!dateString) {
    return 0;
  }
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (useKoranAge) {
    return age + 1;
  }
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }
  return age;
};

export const getAgeGroup = (age: number) => {
  let ageGroup = '';
  if (age < 10) {
    ageGroup = '10';
  } else if (age >= 10 && age < 20) {
    ageGroup = '10';
  } else if (age >= 20 && age < 30) {
    ageGroup = '20';
  } else if (age >= 30 && age < 40) {
    ageGroup = '30';
  } else if (age >= 40 && age < 50) {
    ageGroup = '40';
  } else if (age >= 50 && age < 60) {
    ageGroup = '50';
  } else {
    ageGroup = '99';
  }
  return ageGroup;
};

export const getGender = (type: string) => {
  let gender = '';
  if (type === '01') {
    gender = 'men';
  } else if (type === '02') {
    gender = 'women';
  } else {
    gender = 'all';
  }
  return gender;
};

export const byteArrayHexa = (byteArray: number[]) =>
  Array.prototype.map
    // eslint-disable-next-line no-bitwise
    .call(byteArray, byte => `0${(byte & 0xff).toString(16)}`.slice(-2))
    .join('');

// 배열 중복값 체크.
export const duplicateValueCheck = (arrValue: string[]) => {
  let arr: string[] = [];
  if (arrValue) {
    arr = arrValue.filter((el, idx) => arrValue.indexOf(el) === idx);
  }
  return arr;
};

// 검색어 앞뒤 빈값 제거.
export const setRemoveSpaceKeyword = (value: string) =>
  value.replace(/^\s+|\s+$/g, '');

export const urlToJson = (url: string): { [key: string]: string } => {
  let hash;
  const params = {} as { [key: string]: string };

  // url 내에 queryString이 존재하는 경우에만 object내에 값을 세팅하도록 수정
  if (url.indexOf('?') > -1) {
    const hashes = url.slice(url.indexOf('?') + 1).split('&');

    for (let i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      params[hash[0]] = decodeURIComponent(hash[1]);
    }
  }

  return params;
};

// 스크롤바 width값 가져오기
export const getScrollbarWidth = () =>
  `${window.innerWidth - document.documentElement.clientWidth}px`;

export const uuidv4 = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const sortObject = (o: { [key: string]: any }) =>
  Object.keys(o)
    .sort()
    // eslint-disable-next-line no-return-assign, no-sequences, no-param-reassign
    .reduce((r: { [key: string]: unknown }, k) => ((r[k] = o[k]), r), {});
export const getUniqueKey = () => Math.random().toString(36).substr(2, 9);

export function removeEmptyObject(obj: { [key: string]: any }) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v != null && v !== '')
  );
}
export const copyToClipboard = async (text: string) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Fallback
    }
  }
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    return successful;
  } catch (err) {
    console.error('Copy failed', err);
    return false;
  }
};
